import { createContext, Dispatch, Reducer } from 'react';

export type AvatarUrlActionProps = {
    type: string;
    payload?: string;
    list?: AvatarUserInfos[];
};

export type AvatarUserInfos = {
    avatarUserIdentifier: string | undefined;
    currentUserAvatarUrl: string | undefined;
};

export type AvatarUrlContext = {
    avatarUrl: string | undefined;
    usersAvatarInfos: AvatarUserInfos[] | undefined;
    action: string;
};

export const initialAvatarUrlAction: AvatarUrlContext = {
    avatarUrl: undefined,
    usersAvatarInfos: undefined,
    action: '',
};

export const AvatarUrlActionContext = createContext(initialAvatarUrlAction);
export const AvatarUrlDispatchContext = createContext<Dispatch<AvatarUrlActionProps>>(() => {});

export const AvatarUrlReducer: Reducer<AvatarUrlContext, AvatarUrlActionProps> = (
    state: AvatarUrlContext,
    action: AvatarUrlActionProps,
) => {
    switch (action.type) {
        case 'reset':
            return {
                ...state,
                usersAvatarInfos: undefined,
                avatarUrl: undefined,
                action: action.type,
            };
        case 'update':
            return {
                ...state,
                usersAvatarInfos: action.list,
                avatarUrl: action.payload,
                action: action.type,
            };

        default:
            throw Error(`Unknown action ${action.type}`);
    }
};
